import { Navbar } from '../../components/Navbar/Navbar'
import { ErrorHandler } from '../../components/ErrorHandler/ErrorHandler'
import { fromAxiosError } from '../../context/GlobalError'
import { Box, ImageList, MenuItem, TextField, Theme, Typography } from '@mui/material'
import Button from '@mui/material/Button'
import AddIcon from '@mui/icons-material/Add'
import React, { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { spellsQueryKey } from '../../api/queries'
import { querySpells } from '../../api/queries'
import { ISpell } from '../../api/types/spell'
import makeStyles from '@mui/styles/makeStyles'
import createStyles from '@mui/styles/createStyles'
import { Spell } from './components/Spell/Spell'
import { SpellFormModal } from './components/SpellFormModal/SpellFormModal'
import { onlyUnique } from '../../utils'
import { useWindowWidth } from '../../hooks/useWindowWidth'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    itemsContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      paddingLeft: '16px',
      paddingRight: '16px',
      justifyContent: 'center',
    },
    table: {
      minWidth: 650,
      border: 'none',
    },

    button: {
      margin: theme.spacing(0.5),
    },
  })
)

export const SpellsIndex = () => {
  const { isLoading, error, data: spells } = useQuery<ISpell[]>(spellsQueryKey(), querySpells)
  const [nameFilter, setNameFilter] = useState('')
  const [circleFilter, setCircleFilter] = useState<number>(-1)
  const [schoolFilter, setSchoolFilter] = useState<string>('all')
  const classes = useStyles()
  const windowWidth = useWindowWidth()

  return (
    <>
      <Navbar />
      <ErrorHandler loading={isLoading} error={fromAxiosError(error)}>
        <Box sx={{ padding: '24px', display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="h4" component="h4">
            Czary
          </Typography>
          <Box sx={{ display: 'flex' }}>
            <Box>
              <TextField
                label="Nazwa"
                onChange={e => setNameFilter(e.target.value)}
                sx={{ marginTop: '4px', marginRight: '4px' }}
                size={'small'}
                value={nameFilter}
              />
              <TextField
                select
                label="Szkoła"
                onChange={e => setSchoolFilter(e.target.value)}
                sx={{ minWidth: '100px', marginRight: '4px', marginTop: '4px' }}
                size={'small'}
                value={schoolFilter}
                placeholder={'Szkoła'}
              >
                <MenuItem key={'default'} value={'all'}>
                  Dowolna
                </MenuItem>
                {spells &&
                  spells
                    .map(s => s.school)
                    .filter(onlyUnique)
                    .map(c => (
                      <MenuItem key={c} value={c}>
                        {c}
                      </MenuItem>
                    ))}
              </TextField>
              <TextField
                select
                label="Krąg"
                onChange={e => setCircleFilter(Number(e.target.value))}
                sx={{ minWidth: '80px', marginRight: '4px', marginTop: '4px' }}
                size={'small'}
                value={circleFilter}
                placeholder={'Krąg'}
              >
                <MenuItem key={'default'} value={-1}>
                  Dowolny
                </MenuItem>
                {spells &&
                  spells
                    .map(s => s.circle)
                    .filter(onlyUnique)
                    .map(c => (
                      <MenuItem key={c} value={c}>
                        {c}
                      </MenuItem>
                    ))}
              </TextField>
            </Box>

            <Box sx={{ textAlign: 'right' }}>
              <SpellFormModal title={'Stwórz nowy czar'}>
                {showModal => (
                  <Button
                    variant="outlined"
                    className={classes.button}
                    color="primary"
                    sx={{ height: '40px' }}
                    startIcon={<AddIcon />}
                    onClick={showModal}
                  >
                    Stwórz nowy czar
                  </Button>
                )}
              </SpellFormModal>
            </Box>
          </Box>
        </Box>
        <Box className={classes.itemsContainer}>
          <ImageList variant="masonry" cols={Math.round(windowWidth / 400)} gap={8}>
            {!spells && <></>}
            {spells &&
              spells
                .filter(s => s.name.toLowerCase().includes(nameFilter))
                .filter(s => circleFilter == -1 || s.circle === circleFilter)
                .filter(s => schoolFilter == 'all' || s.school === schoolFilter)
                .map(s => (
                  <Box sx={{ marginBottom: '8px' }} key={s.id}>
                    <Spell spell={s} />
                  </Box>
                ))}
          </ImageList>
        </Box>
      </ErrorHandler>
    </>
  )
}
